import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateUserForm } from '../forms/CreateUserForm';

type CreateUserModalProps = {
  isOpen: boolean;
  profileUuid: string;
  resend?: boolean;
  onClose: () => void;
};

export const CreateUserModal = ({ isOpen, profileUuid, resend, onClose }: CreateUserModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      title={resend ? t('profiles.invite.resendInvitation') : t('persons.createUser')}
      width='s'
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => onClose()}
    >
      <Suspense fallback={<LazyLoader embedded transparent forceHeight='20vh' />}>
        <CreateUserForm profileUuid={profileUuid} onLoad={setLoading} onClose={onClose} />
      </Suspense>
    </Modal>
  );
};
